module.exports = __webpack_public_path__ + "img/1920_about.0131abfc.png";